<template>
  <div class="delivery-block">
    <header>
      <h3>Angaben zum Transport</h3>
    </header>

    <b-form-group label="Transportzweck" label-cols="12" label-cols-md="4" v-if="context.toLowerCase() === 'pigsty'">
      <b-input type="text" :value="context.toLowerCase() === 'piglet' ? 'Nutzung' : 'Schlachtung'" disabled/>
    </b-form-group>

    <b-form-group label="Übernahmestelle:" label-cols="12" label-cols-md="4" v-if="context.toLowerCase() === 'piglet'">
      <app-select
        v-model="data.transferTransportId"
        allow-text-value
        :text-value="data.transferTransport"
        @changeText="text => data.transferTransport = text"
        :options="transportsForTransfer"
        :disabled="disabled || saving"/>
    </b-form-group>

    <b-form-group label="Verladeort:" label-cols="12" label-cols-md="4">
      <app-select
        v-model="data.loadingTransportId"
        allow-text-value
        :text-value="data.loadingTransport"
        @changeText="text => data.loadingTransport = text"
        :options="transportsForLoading"
        :disabled="disabled || saving"/>
    </b-form-group>

    <b-form-group label="Transportbeginn:" label-cols="12" label-cols-md="6">
      <b-input type="datetime-local"
               v-model="data.transportStart"
               style="min-width: 150px;"
               :disabled="disabled || saving"/>
    </b-form-group>

    <b-form-group label="Letzte Fütterung / Tränkung:" label-cols="12" label-cols-md="6">
      <b-input type="datetime-local"
               v-model="data.lastFeeding" style="min-width: 150px;"
               :disabled="disabled || saving" />
    </b-form-group>

    <b-form-group label="Gereinigt und ggf. desinfiziert:" label-cols="12" label-cols-md="6">
      <b-input type="datetime-local"
               v-model="data.cleaned"
               style="min-width: 150px;"
               :disabled="disabled || saving"/>
    </b-form-group>
  </div>
</template>

<script>
import {computed, ref, watch} from '@vue/composition-api'
import ModalSelectFactory from "@/app/components/delivery/ModalSelectFactory.vue";
import AppSelect from "@/app/components/general/AppSelect.vue";

export default {
  components: {AppSelect, ModalSelectFactory},
  props: {
    value: { type: Object, required: true },
    context: { type: String, required: true },
    disabled: { type: Boolean, required: true },
    saving: { type: Boolean, required: true },
  },

  setup(props, { emit }) {
    const store = window.useStore()

    const data = ref(props.value)

    watch(data, () => {
      emit('change', data)
    }, { deep: true })

    const transportsForTransfer = computed(() => {
      return store.state.pwa.deliveries.piglet.config.transport.data
        .filter(t => [1, 5, 6].includes(t.id))
        .map(t => ({
          text: t.name,
          value: t.id,
        }))
    })

    const transportsForLoading = computed(() => {
      return store.state.pwa.deliveries.piglet.config.transport.data
        .filter(t => [1, 5, 6].includes(t.id))
        .map(t => ({
          text: t.name,
          value: t.id,
        }))
    })

    return {
      data,
      transportsForTransfer,
      transportsForLoading,
    }
  }
}
</script>
